import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/top',
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('../views/Auth.vue'),
    meta: {
      layout: 'auth',
    },
  },
  {
    path: '/top',
    name: 'Top',
    component: () => import('../views/Top.vue'),
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import('../views/ActivitiesProvider.vue'),
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/receipts',
    name: 'Receipts',
    component: () => import('../views/ReceiptsProvider.vue'),
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/budgets',
    name: 'Budgets',
    component: () => import('../views/Budgets.vue'),
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('../views/Notifications.vue'),
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/logs',
    name: 'Logs',
    component: () => import('../views/Logs.vue'),
    meta: {
      layout: 'default',
    },
  },
  {
    path: '/downloads',
    name: 'Downloads',
    component: () => import('../views/Downloads.vue'),
    meta: {
      layout: 'default',
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router
